import { buildProps, definePropType } from "@xplus/utils/props";
import type { StepItem } from "./step";
import type { ExtractPropTypes } from "vue";
export const stepsProps = buildProps({
  // modelValue: {
  //   type: [Number, String]
  // },
  active: {
    type: Number,
    default: 0,
  },
  /** 方向 默认水平 */
  direction: {
    type: String,
    default: "horizontal",
    values: ["horizontal", "vertical"],
  },
  space: {
    type: [Number, String],
  },
  /** 步骤条数据
   * 一般有id,title步骤名称 slot插槽 desc 简单的描述
   */
  list: {
    type: definePropType<StepItem[]>(Array),
    default: () => [],
  },
} as const);

export type StepsProps = ExtractPropTypes<typeof stepsProps>;
